import { BaseConditionData } from './base-condition-data';
import { WorkflowConditionTypes } from './Enums/workflow-condition-types';

/**
 * Représente les données d'une condition 'des attributs doivent être renseignés'.
 */
export class AttributesMustBeFilledInConditionData extends BaseConditionData {
    /**
     * Identifiants des attributs devant être renseignés.
     */
    public attributes: number[] = [];

    /**
     * Constructeur.
     */
    constructor() {
        super(WorkflowConditionTypes.AttributesMustBeFilledIn);
    }

    /**
     * Retourne une copie d'une instance de AttributesMustBeFilledInConditionData
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: AttributesMustBeFilledInConditionData) {
        if (!!other) {
            const instance = new AttributesMustBeFilledInConditionData();
            instance.attributes = other.attributes;
            instance.name = other.name;
            instance.type = other.type;
            instance.id = other.id;
            instance.isMainCondition = other.isMainCondition;

            return instance;
        } else {
            return null;
        }
    }
}
